export const rules = {
	// Card titles
	"rules.card.rules.title": "Kanuni",
	"rules.card.goals.title": "Magoli",
	"rules.card.cleanSheets.title": "Clean Sheet",
	"rules.card.cards.title": "Kadi",
	"rules.card.misc.title": "Mengineyo",
	"rules.card.captains.title": "Makamanda na Makamu wa Kapteni",
	"rules.card.eligibility.title": "Ustahiki na Zawadi",
	"rules.card.weeklyPrizes.title": "Muundo wa Zawadi za Kila Wiki",
	"rules.card.finalRules.title": "Ugawaji wa Zawadi na Utatuzi wa Sare",

	// Main rules content
	"rules.intro":
		'Maneno yote yenye herufi kubwa yaliyotumika katika kanuni hizi (<strong>"Kanuni"</strong>) yatakuwa na maana iliyotolewa katika sheria na masharti (<strong>"Sheria na Masharti"</strong>).',

	"rules.rule1":
		"Washiriki wanaweza kuchagua timu yao bora kila wiki/raundi (kama itakavyokuwa), kulingana na mashindano ambayo mchezo wa Betway Scores BW Fantasy Football unahusiana nayo, mfano Ligi Kuu ya Uingereza, n.k. Mashindano ya Betway Scores BW Fantasy Football yataanza tarehe 11 Machi 2025 na yatahitimishwa mwishoni mwa msimu wa mpira wa miguu wa 2025/2026.",

	"rules.rule2": "Kila wiki/raundi inalingana na raundi za ligi hiyo.",

	"rules.rule3":
		"Washiriki wanaweza kuchagua wachezaji wasiozidi wawili (2) kutoka kila timu inayoshiriki kwenye ligi kuingizwa katika timu yao ya Betway Scores BW Fantasy Football kila wiki/raundi.",

	"rules.rule4":
		"Washiriki wanapaswa kuchagua timu yao kila wiki/raundi kwa ufanisi, wakiwa na chaguo la kufanya mabadiliko au kuendelea na timu ile ile kwa wiki/raundi inayofuata.",

	"rules.rule5":
		"Pointi zinatolewa kama ifuatavyo kwa kila kitendo kinachofanywa na wachezaji waliowachagua washiriki katika timu yao ya Betway Scores BW Fantasy Football kila wiki/raundi:",

	// Goals points
	"rules.goals.forwardGoals": "Magoli ya mshambuliaji",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Magoli ya kiungo",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Magoli ya beki",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Magoli ya kipa",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Magoli ya penalti",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Magoli ya kujifunga",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Magoli yaliyofungwa",
	"rules.goals.concededGoalsValue": "-1",

	// Clean sheets points
	"rules.cleanSheets.goalkeeperCleanSheet": "Clean sheet ya kipa",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Clean sheet ya beki",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Clean sheet ya kiungo",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Cards points
	"rules.cards.yellowCard": "Kadi ya njano",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Kadi nyekundu",
	"rules.cards.redCardValue": "-5",

	// Misc points
	"rules.misc.assists": "Assist",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Mashuti yaliyolenga goli",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Tackles",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Saves",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Dakika zilizochezwa sawa au zaidi ya 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Dakika zilizochezwa chini ya 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Penalti iliyopatikana",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Penalti iliyosababisha",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Penalti iliyokosa",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Offside",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Makosa yaliyofanywa",
	"rules.misc.foulsCommittedValue": "-1",

	// Captain rules
	"rules.rule6":
		'Washiriki wanaweza kumteua <strong>"Kapteni"</strong> kwenye timu yao atakayepata alama mara 3. Kapteni anaweza kubadilishwa kila wiki/rau ndi. Iwapo Kapteni atabadilishwa au kubaki yule yule kwa wiki/rau ndi inayofuata, lazima ichaguliwe kwa ufanisi kila wiki/rau ndi na mshiriki.',

	"rules.rule7":
		'Washiriki wanaweza kumteua <strong>"Makamu wa Kapteni"</strong> kwenye timu yao atakayepata alama mara 2. Makamu wa Kapteni anaweza kubadilishwa kila wiki/rau ndi. Iwapo atabadilishwa au kubaki yule yule kwa wiki/rau ndi inayofuata, lazima ichaguliwe kwa ufanisi kila wiki na mshiriki.',

	// Eligibility and prizes
	"rules.rule8":
		"Wote waliojiandikisha kwenye Betway Scores na/au BW Scores wanaweza kucheza BW Fantasy Football, lakini ni washiriki wenye akaunti ya Betway iliyothibitishwa wakati wa utoaji wa zawadi pekee watakaostahili kushinda zawadi. Mabadiliko ya matokeo ya raundi kama ilivyoelezwa kwenye kipengele cha 2 hapo juu (yanayoathiri pointi kwenye kipengele cha 5 hapo juu) yatakayotokea baada ya utoaji wa zawadi hayatashughulikiwa tena.",

	"rules.rule9":
		"Mshiriki anayestahiki na anayemaliza msimu akiwa wa kwanza na ana Akaunti ya Kubeti ya Betway atakuwa mshindi wa Zawadi Kuu ya msimu na atashinda safari kwa watu wawili (2) kwenda kutazama Arsenal ikicheza London, ikijumuisha nauli ya ndege (ikihitajika), malazi (ikihitajika) na pauni 500 (£500) za matumizi.",

	"rules.rule10":
		"Iwapo mshindi wa Zawadi Kuu hatoweza kusafiri kwa sababu ya kukosa pasi halali ya kusafiria na/au Visa na/au vizuizi vingine, atapokea zawadi ya salio la pesa taslimu €5,000, au sawa na kiasi hicho kwa sarafu ya nchi husika mwanzoni mwa mashindano (ikiwa ni £4,500, R100,000 au GH₵ 60,000), kwenye Akaunti yake ya Betway mara mashindano yatakapomalizika.",

	"rules.rule11":
		"Mshindi wa Zawadi Kuu anaweza kuamua kutochukua safari hiyo na badala yake apokee zawadi ya salio la pesa taslimu €5,000, au sawa na kiasi hicho kwa sarafu ya nchi husika mwanzoni mwa mashindano (ikiwa ni £4,500, R100,000 au GH₵ 60,000), kwenye Akaunti yake ya Betway.",

	"rules.rule12":
		"Zawadi za Kila Wiki zitatolewa kwa washindi 10 bora kila wiki/rau ndi wenye Akaunti halali ya Kubeti ya Betway. Ikiwa mshindi aliye kwenye Top 10 hana Akaunti ya Kubeti ya Betway, hatapewa zawadi hiyo ya kila wiki.",

	"rules.rule13":
		"Nafasi za kila wiki kuanzia 1 hadi 10 zitashinda kiasi cha salio la pesa taslimu kulingana na kanda, kitakachoingizwa kwenye Akaunti ya Betway:",

	// Weekly prize table headers
	"rules.weeklyPrizes.position": "Nafasi Kila Raundi",
	"rules.weeklyPrizes.eur": "Ushindi wa Salio la Pesa Taslimu (EUR)",
	"rules.weeklyPrizes.gbp": "Ushindi wa Salio la Pesa Taslimu (GBP)",
	"rules.weeklyPrizes.zar": "Ushindi wa Salio la Pesa Taslimu (ZAR)",
	"rules.weeklyPrizes.ghs": "Ushindi wa Salio la Pesa Taslimu (GHS)",

	// Weekly prize values
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Final rules
	"rules.rule14":
		"Zawadi za Kila Wiki zitatolewa ndani ya siku 7 (saba) baada ya matokeo ya wiki hiyo kuthibitishwa, na Zawadi Kuu itatolewa ndani ya siku 7 (saba) baada ya mashindano ya Betway Scores BW Fantasy Football kuhitimishwa.",

	"rules.rule15":
		"Iwapo kutakuwa na sare kwenye Zawadi za Kila Wiki, salio la pesa kwa nafasi hiyo (na nafasi husika zilizoathirika na sare hiyo) litagawanywa kwa usawa kati ya washiriki waliofungana.",

	"rules.rule16":
		"Iwapo kutakuwa na sare kwa Zawadi Kuu, chombo cha kuchagua kwa bahati kitumike kumchagua mshindi mmoja pekee kati ya washiriki waliofungana.",

	"rules.temporary_notice":
		"Tafadhali kumbuka kuwa washindi wa zawadi katika kipindi cha tarehe 19 Desemba 2025 hadi 2 Januari 2026 watapokea zawadi zao ndani ya siku 7 (saba) kuanzia tarehe 6 Januari 2026",
};
